import type { CouponClaimStatus } from '@evi/shared';
import type { PillTone } from '../components/primitives/StatusPill';

/** The pill on a claimed coupon card. The Api reports an unused claim past
 *  its coupon's last Los Angeles day as `expired` (GET /coupons): it can no
 *  longer discount a session or a top-up, so it is not the green Claimed. */
export function couponClaimPill(status: CouponClaimStatus | undefined): {
  tone: PillTone;
  labelKey: 'card.applied' | 'card.expired' | 'card.claimed';
} {
  if (status === 'applied') return { tone: 'accent', labelKey: 'card.applied' };
  if (status === 'expired') return { tone: 'mute', labelKey: 'card.expired' };
  return { tone: 'good', labelKey: 'card.claimed' };
}
